<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>

    <el-button
      :disabled="dataList.length === 0"
      type="success"
      size="small"
      icon="el-icon-download"
      @click="onDownloadBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch
          :default-unit-prop.sync="unitProp"
          @change="onUnitPropChange"
        />

        <display-type
          :default-display-type.sync="displayType"
          style="margin-left:20px;"
          @change="onDisplayTypeChanged"
        />

        <dimension-type :default-dimension-type.sync="dimension" @change="onDimensionChanged" />

        <el-button size="small" @click="onOpenEditor">标记说明</el-button>
      </template>

      <data-table
        v-if="displayType === 1"
        ref="dataTable"
        :key="dataTableKey"
        :columns="tableColumns"
        :data="tableDataList"
        :pagination="pagination"
        selected-style
      />

      <template v-else>
        <x-y-chart
          v-for="data in dataList"
          v-if="data.dimensions.length > 0"
          :key="data.id"
          :data-config="data"
          :unit-prop="unitProp"
          chart-type="line"
          :stack-type="0"
          :download-name="downloadName"
          chart-min-height="400px"
          chart-height="auto"
          selected-change-with-data-changed
          style="flex:1 0 100%;"
        />
      </template>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
    />
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../BaseSiteFactorData'
import DataFormatter from '../../../model/DataFormatter'
import CSVDownloader from '../../../utils/CSVDownloader'

import LayoutContent from '../../../components/Layout/Content'
import DataTimeQuery from '../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../components/Data/DataWrapper'
import UnitSwitch from '../../../components/Data/UnitSwitch'
import DisplayType from '../../../components/Data/DisplayType'
import DimensionType from '../../../components/Data/DimensionType'
import XYChart from '../../../components/DataChart/XYChart'
import DeviceCategoryConfig from '../../../model/DeviceCategoryConfig'
import Editor from '../../06Data-Management/00Data-Download/Editor.vue'

const DIMENSION_CONFIGS = [{
  id: 'siteName',
  label: '站房',
  showUnit: true
}, {
  id: 'factorName',
  label: '因子',
  showUnit: false
}]

export default {
  name: 'GHG',
  routeInfo: {
    label: '温室气体',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, DisplayType, DimensionType, XYChart, Editor},
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    displayType: 2,
    dataTableKey: 0,
    tableColumns: Object.freeze([]),
    tableDataList: Object.freeze([]),
    pagination: {
      no: 1,
      size: 24
    }
  }),
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, true)
      ]
    },
    downloadName: () => '湿室气体',
    currentDimensions () {
      return Object.values(this.dataList.reduce((map, dataConfig) => dataConfig.dimensions.reduce((map, dimension) => {
        let dimensionId = dimension.id

        if (!map[dimensionId]) {
          map[dimensionId] = dimension
        }

        return map
      }, map), {}))
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      return {
        type: 'line',
        showSymbol: false
      }
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(DataFormatter.formatWeatherDataList.bind(this)(dataList))
      this.formatData()
    },
    getEditor () {
      return this.$refs['editor']
    },
    onOpenEditor (model) {
      let refEditor = this.getEditor()
      refEditor && refEditor.open()
    },
    onDownloadBtnClick () {
      let {currentQuery: {beginTime, endTime}, tableColumns, dataList, currentDimensions, unitProp} = this
      let dimensionConfig = DIMENSION_CONFIGS[this.dimension]
      let filename = `${new Date(beginTime).format('YYYY-MM-DD')}_${new Date(endTime).format('YYYY-MM-DD')}`
      let tableColumnsLen = tableColumns.length
      let csvDataList = []

      let headerColumns = ['', '']
      for (let i = 2; i < tableColumnsLen; i++) {
        headerColumns.push(tableColumns[i].name, '')
      }
      csvDataList.push(headerColumns)

      headerColumns = [tableColumns[0].name, tableColumns[1].name]
      for (let i = 2; i < tableColumnsLen; i++) {
        headerColumns.push('监测值', `标记`)
      }
      csvDataList.push(headerColumns)

      dataList.reduce((csvDataList, dataConfig) => {
        let {name, seriesMap} = dataConfig
        let {dimensions} = dataConfig

        return dataConfig.dataTimes.reduce((csvDataList, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          csvDataList.push(currentDimensions.reduce((csvDataRow, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]

            if (seriesItem) {
              // let data = seriesItem[dataTime]

              // if (data && data.value && Number.isFinite(data.value)) {
              //   csvDataRow.push(data.value || data.noDataReason || '', `${data.dasFlag}${isAuditCompleted ? `, ${data.auditFlag}` : ''}`)
              // } else {
              //   csvDataRow.push('--', '--')
              // }

              let data = seriesItem[dataTime] || {}
              const {value} = data
              const flags = []

              if (data.isHaveIntegral) {
                flags.push('重积分')
              }

              const displayFlags = data.displayFlags || []

              if (displayFlags[0]) {
                flags.push(displayFlags[0])

                if (displayFlags[1]) {
                  flags[flags.length - 1] += `: ${displayFlags[1]}`
                }
              }

              csvDataRow.push(Number.isFinite(value) ? value : '--', flags.join(','))
            } else {
              csvDataRow.push('--', '--')
            }

            return csvDataRow
          }, [dataTime, `${name}${!dimensionConfig.showUnit && dimensions[0] && dimensions[0][unitProp] ? `(${dimensions[0][unitProp]})` : ''}`]))
          return csvDataList
        }, csvDataList)
      }, csvDataList)

      CSVDownloader(csvDataList, filename)
    },
    onDisplayTypeChanged (displayType) {
      if (displayType === 1) {
        setTimeout(() => {
          this.$refs.dataTable.doLayout()
        }, 0)
      }
    },
    onDimensionChanged () {
      this.formatData()
    }
  },
  watch: {
    dataList (dataList) {
      let {unitProp} = this
      let dimensionConfig = DIMENSION_CONFIGS[this.dimension]
      let {showUnit} = dimensionConfig

      this.tableColumns = Object.freeze(this.currentDimensions.reduce((tableColumns, factor) => {
        let unit = factor[unitProp]
        tableColumns.push({
          id: factor.id,
          name: `${factor.name}${showUnit && unit ? `(${unit})` : ''}`,
          width: 200,
          align: 'left'
        })
        return tableColumns
      }, [{
        id: 'dataTime',
        name: '时间',
        width: 160,
        align: 'left',
        fixed: true
      }, {
        id: dimensionConfig.id,
        name: dimensionConfig.label,
        width: 160,
        align: 'left',
        fixed: true
      }]))

      this.tableDataList = Object.freeze(dataList.reduce((list, dataConfig) => {
        let {name, dimensions, seriesMap} = dataConfig
        return dataConfig.dataTimes.reduce((list, dataTimeObj) => {
          let dataTime = dataTimeObj[1]
          list.push(dimensions.reduce((formatData, dimension) => {
            let dimensionId = dimension.id
            let seriesItem = seriesMap[dimensionId]
            let data = seriesItem[dataTime]
            // // 3.7前版本 formatData[dimensionId] = data ? (Number.isFinite(data.value) ? `${data.value}(${data.dasFlag}${isAuditCompleted ? `, ${data.auditFlag}` : ''})` : (data.noDataReason || '__')) : '--'
            // if (isAuditCompleted) {
            //   if (data.auditFlag !== 'DELETE') {
            //     formatData[dimensionId] = data.value ? data.value : '--'
            //   } else {
            //     formatData[dimensionId] = '--'
            //   }
            // } else {
            //   formatData[dimensionId] = data ? (Number.isFinite(data.value) ? `${data.value}(${data.dasFlag}${isAuditCompleted ? `, ${data.auditFlag}` : ''})` : (data.noDataReason || '__')) : '--'
            // }

            if (data) {
              const {value, displayFlags} = data
              formatData[dimensionId] = Number.isFinite(value) ? `${value}${displayFlags[0] ? `(${displayFlags[0]}${displayFlags[1] ? `: ${displayFlags[1]}` : ''})` : ''}` : (displayFlags[0] ? `${displayFlags[0]}${displayFlags[1] ? `: ${displayFlags[1]}` : ''}` : '--')
              formatData[dimensionId + 'Integral'] = data.isHaveIntegral
            } else {
              formatData[dimensionId] = '--'
            }

            return formatData
          }, {
            [dimensionConfig.id]: `${name}${!showUnit && dimensions[0] && dimensions[0][unitProp] ? `(${dimensions[0][unitProp]})` : ''}`,
            dataTime
          }))
          return list
        }, list)
      }, []))

      if (this.displayType !== 1) {
        return
      }

      this.pagination.no = 1

      setTimeout(() => {
        this.$refs.dataTable.doLayout()
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-content-wrapper {
  /deep/ {
    .layout-content-body {
      .layout-content-body-inner {
        overflow: hidden !important;
      }
    }
  }
}

.integral-data {
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/03GHG/index.vue